export enum VirtualCardActionType {
    CARD_REQUIRES_AUTHENTICATION = "CARD_REQUIRES_AUTHENTICATION",
    CARD_WRONG_PIN = "CARD_WRONG_PIN",
    CARD_CHECK_SUCCESS = "CARD_CHECK_SUCCESS",
    CARD_CHECK_ERROR = "CARD_CHECK_ERROR",
    BADGE_CHECK_SUCCESS = "BADGE_CHECK_SUCCESS",
    BADGE_CHECK_ERROR = "BADGE_CHECK_ERROR",
}
